import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {bodyArea} from "../../../models/bodyArea";
import {scrollTo} from "../../../service/ToolsService";

type BodyAreaListProp = {
  bodyAreas: bodyArea[],
  loading?: boolean,
  refresh: () => void,
}

export const BodyAreaList = ({bodyAreas, loading, refresh}: BodyAreaListProp) => {
  const [del, setDel] = useState(undefined as undefined | bodyArea);

  const deleteBodyArea = async (bodyArea: bodyArea) => {
    await ApiService.delete(`/body-area/${bodyArea.bodyAreaId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={3} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && bodyAreas.map((bodyArea: bodyArea, i: number) => (
          <tr key={i} className="align-middle">
            <td>{bodyArea.label}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(bodyArea.updatedAt ?? bodyArea.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/equipment/body-area/edit/${bodyArea.bodyAreaId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(bodyArea)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteBodyArea(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
